<template>
    <figure class="image is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only" style="margin-top: 30px;">
        <img src="https://assets.webbank.com/newsroom/pr53_hero.png" alt="WebBank Announces Erik Cannon Named EVP – Chief Operations Officer">
    </figure>
    <figure class="image is-hidden-widescreen">
        <img src="https://assets.webbank.com/newsroom/pr53_small.png" alt="WebBank Announces Erik Cannon Named EVP – Chief Operations Officer">
    </figure>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">

                    <router-link class="button is-primary is-small is-pulled-right" to="/newsroom">
                        <span class="icon"><i class="fas fa-arrow-left"></i></span>
                        <span>Back to Newsroom</span>
                    </router-link>
                    <p class="press-release">Press Release</p>
                    <br>
                    <div class="content">
                        <h2 class="news-page-title">WebBank Announces Erik Cannon Named EVP – Chief Operations Officer</h2>
                        <br>
                        <p><em><small>April 23, 2026</small></em></p>
                        <br>
                        <p><strong>SALT LAKE CITY</strong> – WebBank today announced the promotion of Erik Cannon to Executive Vice President, Chief Operations Officer. In this expanded role, Erik will continue advancing operational excellence across the Bank while driving strategic alignment and scalable growth.</p>
                        <p>Erik joined WebBank in 2016 and was originally responsible for leading the Bank’s Due Diligence and Implementation team. Since that time, he has assumed executive oversight of the Strategic Partners Oversight team, the Bank’s Insurance Premium Finance subsidiary, National Partners, and the Bank’s Partner Finance team. His leadership across these areas has strengthened operational discipline, enhanced cross-functional collaboration and supported WebBank’s continued growth.</p>
                        <p>Erik brings extensive experience in international operations, strategy development, relationship management, product development and the design, optimization and implementation of complex business systems and processes. He is known for his ability to identify opportunities for greater efficiency, build structured solutions and implement processes that improve performance while supporting long-term scalability.</p>
                        <p>“Erik’s leadership has been instrumental in shaping the strength and continued growth of WebBank,” said Jason Lloyd, President & CEO. “He leads with both strategic vision and operational discipline that enables him to identify opportunities for greater effectiveness and translate complex challenges into disciplined, scalable processes. His executive presence and steady leadership have been instrumental in the success and performance of the teams under his oversight. I am confident he will continue to elevate the organization in his role as Executive Vice President.”</p>
                        <p>As EVP, Chief Operations Officer, Erik will focus on strengthening enterprise-wide operations, refining process excellence and supporting WebBank’s continued expansion through disciplined execution and strong partner alignment.</p>
                        <br>
                        <p><strong>About WebBank</strong></p>
                        <p>WebBank is a Utah chartered Industrial Bank headquartered in Salt Lake City, Utah. Since its inception in 1997, WebBank has originated and funded over $273 billion in consumer and commercial credit products.  As “The Bank Behind the Brand®”, WebBank is a national issuer of consumer and small business credit products through Strategic Partner (Brand) platforms, which include retailers, manufacturers, finance companies, software as a service (SaaS) and financial technology (FinTech) companies.  The Bank is a leading player in the digital lending space, driving innovation in financial products through embedded finance with Strategic Partner platforms.  WebBank engages in a full range of banking activities including consumer and commercial loan products, revolving lines of credit, credit cards, private-label card issuance, auto-refinancing and more. The Bank provides capital in the form of asset-based lending and other credit facilities to Strategic Partner platforms, credit funds, and other lenders with a targeted focus on specialty finance assets. The Bank is also a leading provider of commercial insurance premium finance products through its wholly owned subsidiary National Partners. For more information, please visit <a href="/">www.webbank.com</a>.</p>
                        <br>
                        <p><strong>Media Contact:</strong></p>
                        <p>Shannon Hutchings</p>
                        <p><a href="mailto:shannon.hutchings@webbank.com">shannon.hutchings@webbank.com</a></p>
                    </div>

                    <div class=" modal" :class="{ 'is-active': clickout_modal }">
                        <div class="modal-background"></div>
                        <div class="modal-content">
                            <div class="box">
                                <h2 class="box-title">You are leaving our site!</h2>
                                <br>
                                <p>You will be linking to another website not owned or operated by WebBank.</p>
                                <br>
                                <p>WebBank is not responsible for the availability or content of this website
                                    and does not represent either the linked website or you, should you enter into a
                                    transaction.</p>
                                <br>
                                <p>The inclusion of any hyperlink does not imply any endorsement, investigation,
                                    verification or monitoring by WebBank of any information in any hyperlinked
                                    site. We encourage you to review their privacy and security policies which may differ
                                    from WebBank.</p>
                                <br>
                                <p>If you click &quot;Proceed&quot;, the link will open in a new window.</p>
                                <br>
                                <br>
                                <div class="field is-grouped">
                                    <div class="control">
                                        <button class="button is-link" @click="doClickout">Proceed</button>
                                    </div>
                                    <div class="control">
                                        <button class="button is-link is-light"
                                            @click="clickout_modal = false">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

    created() {
        document.title = "PayPal Surpasses $30B";
    },

    data: function () {
        return {
            clickout_modal: false,
            clickout_url: null,
        }
    },

    methods: {
        clickOutWarning: function (url) {
            this.clickout_url = url;
            this.clickout_modal = true;
        },


        doClickout: function () {
            this.clickout_modal = false;
            window.open(this.clickout_url, "_blank");
        },
    }
}
</script>
